import React from 'react';
import TermsConditionsData from '../components/terms-conditions-data';
import usePageMeta from '../hooks/usePageMeta';

export default function TermsConditions() {
    usePageMeta(
        'Terms & Conditions | Spinnennetz',
        'Read the Terms and Conditions for using Spinnennetz\'s website and services, covering service agreements, intellectual property, payment terms, confidentiality, and governing law.',
        '/terms-and-conditions',
        {
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "Terms & Conditions | Spinnennetz",
            "description": "Terms and Conditions for using Spinnennetz's website and CRO, web development, and eCommerce services."
        }
    );

    return (
        <>
            <TermsConditionsData />
        </>
    );
}
